import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Brightness4Icon(props: IconProps) {
    return <Icon {...props} iconKey={"brightness_4"}/>
}
